import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ContecLogo.png'
import _imports_1 from '@/assets/images/MobileLogo.png'
import _imports_2 from '@/assets/images/SideLogo.png'
import _imports_3 from '@/assets/images/PolicyIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-5597bcc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "layout_inner_wrap"
}
const _hoisted_2 = {
  key: 0,
  class: "logined_main_logo",
  src: _imports_1,
  alt: "Mobile mainLogo"
}
const _hoisted_3 = { class: "layout_inner" }
const _hoisted_4 = {
  key: 0,
  class: "main_logo",
  src: _imports_2,
  alt: "Mobile mainLogo"
}
const _hoisted_5 = {
  key: 0,
  class: "bottom_text_center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bottom_text_bold" }, " COPY RIGHT ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bottom_text_regular" }, " CONTEC Co., Ltd. all right reserved ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "PolicyIcon"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "orbit_spinner_wrap"
}

import { storeToRefs } from 'pinia';
import { OrbitSpinner } from 'epic-spinners';

import LoginBox from '@/components/common/LoginBox.vue';
import FailedModal from '@/components/common/modal/FailedModal.vue';
import ForgotAccountModal from '@/components/common/modal/ForgotAccountModal.vue';
import LicenseModal from '@/components/common/modal/LicenseModal.vue';
import SuccessModal from '@/components/common/modal/SuccessModal.vue';
import SatelliteInfo from '@/components/common/SatelliteInfo.vue';
import IconButtons from '@/components/mobile/IconButtons.vue';
import LoginedPanel from '@/components/mobile/LoginedPanel.vue';
import ImageModeSvg from '@/assets/images/Svgs/ImageModeSvg.vue';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';



export default /*#__PURE__*/_defineComponent({
  __name: 'MobileLayout',
  setup(__props) {

const { isLoading, isImageMode } = storeToRefs(useCommonStore());
const { imageModeToggle, LicenseModalToggle, windowSize, showPanel, showModal } = useCommonStore();
const { accessedMemberInfo } = useMemberStore();

const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showMainLogo':
      return !!((accessedMemberInfo.name || windowSize.width > windowSize.height) && (!showPanel.isMobileAccountInfo || windowSize.width > windowSize.height));
    case 'showContecLogo':
      return !isImageMode.value && windowSize.width > windowSize.height || showModal.isLicense || showPanel.isMobileAccountInfo;
    case 'showSideLogo':
      return !accessedMemberInfo.name && windowSize.width < windowSize.height;
    case 'showMobileLayout':
      return !isImageMode.value && !showModal.isLicense;
    case 'showMobileContents':
      return !accessedMemberInfo.name && windowSize.width < windowSize.height;
    case 'showLoginBox':
      return showPanel.isLogin && !showModal.isForgotAccount && !showModal.isFail && !showModal.isSuccess;
    case 'showContentsSatelliteInfo':
      return !showPanel.isLogin && !showModal.isFail;
    case 'showSatelliteInfo':
      return !showPanel.isMobileAccountInfo || (showPanel.isMobileAccountInfo && windowSize.width > windowSize.height);
    case 'showBottomText':
      return windowSize.height > 720 && windowSize.width < windowSize.height;
    case 'showImageModeBtn':
      return isImageMode.value && (windowSize.width > 1280 && windowSize.height > 720);
    case 'showMobileLicenseBtn':
      return !isImageMode.value && (!showPanel.isMobileAccountInfo || windowSize.width > windowSize.height);
    case 'disabledMobileLicenseBtn':
      return windowSize.width < windowSize.height && (showModal.isFail || showModal.isForgotAccount);
    case 'biggerHeight':
      return windowSize.width < windowSize.height;
    default:
      return false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout", {'opacity' : _unref(showModal).isForgotAccount}])
  }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (qualificationFunction('showContecLogo'))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: _normalizeClass(["logo", { 'logined_logo' : _unref(accessedMemberInfo).name }]),
              src: _imports_0,
              alt: "Contec Logo"
            }, null, 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (qualificationFunction('showMobileLayout'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (qualificationFunction('showMainLogo'))
                    ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                (qualificationFunction('showMobileContents'))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                  : _createCommentVNode("", true),
                (qualificationFunction('showMobileContents'))
                  ? (_openBlock(), _createBlock(_TransitionGroup, {
                      key: 1,
                      tag: "div",
                      name: "fade",
                      class: "contents"
                    }, {
                      default: _withCtx(() => [
                        (qualificationFunction('showLoginBox'))
                          ? (_openBlock(), _createBlock(LoginBox, { key: 0 }))
                          : _createCommentVNode("", true),
                        (qualificationFunction('showContentsSatelliteInfo'))
                          ? (_openBlock(), _createBlock(SatelliteInfo, { key: 1 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_Transition, {
                      key: 2,
                      name: "fade"
                    }, {
                      default: _withCtx(() => [
                        (qualificationFunction('showSatelliteInfo'))
                          ? (_openBlock(), _createBlock(SatelliteInfo, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
              ]),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (qualificationFunction('showBottomText'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(IconButtons)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(isImageMode))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "image_mode_btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(imageModeToggle) && _unref(imageModeToggle)(...args)))
            }, [
              _createElementVNode("span", null, [
                _createVNode(ImageModeSvg)
              ]),
              _createTextVNode(" IMAGE MODE ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (qualificationFunction('showMobileLicenseBtn'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "license_btn",
              type: "button",
              disabled: qualificationFunction('disabledMobileLicenseBtn'),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(LicenseModalToggle) && _unref(LicenseModalToggle)(...args)))
            }, _hoisted_11, 8, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(LoginedPanel),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_unref(OrbitSpinner), {
                animationDuration: 1200,
                fill: "$color-white"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (qualificationFunction('biggerHeight'))
      ? (_openBlock(), _createBlock(SuccessModal, { key: 0 }))
      : _createCommentVNode("", true),
    (qualificationFunction('biggerHeight'))
      ? (_openBlock(), _createBlock(FailedModal, { key: 1 }))
      : _createCommentVNode("", true),
    (qualificationFunction('biggerHeight'))
      ? (_openBlock(), _createBlock(ForgotAccountModal, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(LicenseModal)
  ], 2))
}
}

})